import { CellContext } from '@tanstack/react-table';
import { SimpleNestedInsurance } from '@/features/dashboard/insurances/types/SimpleNestedInsurance.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const nestedInsuranceFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as SimpleNestedInsurance | null | undefined;
  if (!value) return <EmptyValue />;
  return value.name;
};
